module.exports = __webpack_public_path__ + "img/facebook.1be87c06.svg";